module.exports = __webpack_public_path__ + "media/images/icon-calendar-2eb6f9b1bafde5b22ac0b006ee1a9ead.svg";